import React, {Component} from 'react';
import {connect} from "react-redux";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import SelectBox from "../components/EditorialSelectBox";
import axios from "axios";
import getAxiosConfig from "../../../utils/axiosConfig";
import axiosConfig from "../../../utils/axiosConfig";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import PanelLayout from "../components/PanelLayout";
import EditorialEntitiesList from "../components/EditorialItemList/components/EditorialEntitiesList";
import {SearchButton} from "../components/EditorialItemList/components/buttons/SearchButton";
import messageCodes from "../../../utils/messageCodes";

class EditorialPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: "",
            searchedOption: "",
            showSearchedProperty: "",
            searchText: "",
            itemProperties: [],
            searchOptions: [],
            items: [],
            selectedItems: this.props.clickedNodeInfo.extras.options.selectedItems ? this.props.clickedNodeInfo.extras.options.selectedItems : [],
            paginationModel: {
                page: 0,
                pageSize: 5
            }
        };
        this.handleGetItems = this.handleGetItems.bind(this);
        this.getItems = this.getItems.bind(this);
        this.addSelectedItem = this.addSelectedItem.bind(this);
        this.removeSelectedItem = this.removeSelectedItem.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.onPaginationModelChange = this.onPaginationModelChange.bind(this);
        this.handleGetItemsResponse = this.handleGetItemsResponse.bind(this);
        this.updateProperty = this.updateProperty.bind(this);
        this.getItemUserProperties = this.getItemUserProperties.bind(this);
    }

    componentDidMount() {
        if((this.state.selectedItems.length > 0)) {
            const body = this.state.selectedItems.map(item => item.itemId ? item.itemId : item.entityId);
            axios.post(this.props.properties.databaseUrl + "/items/ids", body, axiosConfig())
                .then(response => {
                    this.setState({
                        ...this.state,
                        selectedItems: response.data
                    })
                })
                .catch(err => {
                    if (err.response)
                        this.props.showToastForBackend(err.response.data);
                    else
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                })
        }
    }

    getItemUserProperties() {
        const itemProperties = this.state.itemProperties;

        if (itemProperties.length === 0) {
            axios.get(this.props.properties.databaseUrl + "/properties/items", axiosConfig())
                .then(response => {
                    const searchOptions = [];

                    searchOptions.push({label: "itemId", value: "itemId"});
                    searchOptions.push(...response.data.sort().map(x => ({label: x, value: x})));

                    this.forceUpdate(() =>  this.setState(prev => {
                        return {
                            ...this.state,
                            searchOptions,
                            selectedOption: "itemId",
                            searchedOption: "itemId"
                        }
                    }))
                })
                .catch(err => {
                    if (err.response)
                        this.props.showToastForBackend(err.response.data);
                    else
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        }
    }

    updateOptions() {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let editorialInfo = { ...clickedNodeInfo };
        editorialInfo.extras.options.selectedItems = this.state.selectedItems.map(({ itemId, entityId }) => ({
            itemId: Array.isArray(itemId) ? itemId[0] : itemId,
            entityId: Array.isArray(entityId) ? entityId[0] : entityId
        }));
        this.props.clickedNodeAction(editorialInfo);
    }

    handleSelection(event) {
        const value = event.target.value;
        this.setState({selectedOption: value});
    }

    onPaginationModelChange(newPageModel){
        this.setState({paginationModel: newPageModel})
    }

    getItems(){
        if (this.state.searchText !== "") {
            if (this.state.searchedOption === 'itemId') {
                axios.get(this.props.properties.databaseUrl + "/items/" + this.state.searchText, getAxiosConfig())
                    .then(response => {
                        this.handleGetItemsResponse(response)
                    })
                    .catch((err) => {
                        if (err.response) {
                            this.props.showToastForBackend(err.response.data);
                        }
                    });
            } else {
                const query = `map['${this.state.searchedOption}'] != null && map['${this.state.searchedOption}'].?[#this == '${this.state.searchText}'].length>0`
                let requestBody = {
                    limit: this.state.paginationModel.pageSize,
                    offset: this.state.paginationModel.page * this.state.paginationModel.pageSize,
                    spelFilter: query
                }
                axios.post(this.props.properties.databaseUrl + "/items", requestBody, getAxiosConfig())
                    .then(response => this.handleGetItemsResponse(response))
                    .catch((err) => {
                        if (err.response) {
                            this.props.showToastForBackend(err.response.data);
                        }
                    });
            }
            this.setState({
                showSearchedProperty: this.state.searchedOption
            })
        }
    }

    handleGetItems(event) {
        event.preventDefault();
        this.getItems();
    }

    handleGetItemsResponse(response) {
        if (response.data === "Offset is equal or greater than the size of the result") {
            this.setState({items: []})
        }else {
            let items;
            if(Array.isArray(response.data)){
                items = response.data.map(item => ({ ...item }));
            }else{
                items = [response.data];
            }
            this.setState({items}, () => {
                this.state.selectedItems.forEach(selectedItem => {
                    if (this.state.items.some(item => item.itemId === selectedItem.itemId)) {
                        this.updateProperty("added", selectedItem.itemId, true);
                    }
                });
            });
        }
    }

    updateProperty(field, property, value) {
        this.setState(prevState => ({
            items: prevState.items.map((item) => {
                if (item.itemId === property) {
                    item = {...item, [field]: value};
                    return item;
                }
                return item;
            })
        }));
    }

    addSelectedItem(item) {
        this.setState(prevState => ({
            selectedItems: [
                ...prevState.selectedItems,
                item
            ]
        }), () => {
            this.updateOptions();
        });
        this.updateProperty("added", item.itemId, true);
    }

    removeSelectedItem(item) {
        const index = this.state.selectedItems.findIndex(selectedItem => selectedItem.itemId === item.itemId);
        this.setState(prevState => ({
            selectedItems: [...prevState.selectedItems.slice(0, index), ...prevState.selectedItems.slice(index + 1)]
        }), () => {
            this.updateOptions();
        });
        this.updateProperty("added", item.itemId, false);
    }

    setSelected(item) {
        if (!item.added) {
            this.setState(prevState => ({
                items: prevState.items.map((item) => {
                    item = {...item, selected: false};
                    return item;
                })
            }), () => {
                this.updateProperty("selected", item.itemId, !item.selected);
            });
        }
    }

    render() {
        return (
            <PanelLayout className="editorial-panel">
                <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule editorial-filter-rule">
                            <form className="input-container" onSubmit={(event) => this.handleGetItems(event)}>
                                <span className="label editorial-label">Search by:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.setState({searchedOption: event.target.value})}
                                    selectValue={this.state.searchedOption}
                                    selectArray={this.state.searchOptions}
                                    className="editorial-field"
                                    load={this.getItemUserProperties}
                                />
                                <input className="text-input editorial-field editorial-input"
                                       value={this.state.searchText}
                                       onChange={(event) => this.setState({searchText: event.target.value})}
                                />
                                <SearchButton/>
                            </form>
                        </div>
                    </div>
                </div>
                <EditorialEntitiesList label="Items"
                                       onSelect={(event) => this.handleSelection(event)}
                                       state={this.state}
                                       items={this.state.items}
                                       action={this.addSelectedItem}
                                       actionType={"add"}
                                       onPaginationModelChange={this.onPaginationModelChange}
                                       getItems={this.getItems}
                                       properties={this.props.properties}
                />
                <EditorialEntitiesList label="Selected Items"
                                       onSelect={(event) => this.handleSelection(event)}
                                       state={this.state}
                                       items={this.state.selectedItems}
                                       action={this.removeSelectedItem}
                                       actionType={"remove"}
                />
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo,
        properties: state.properties,
        itemProperties: state.itemProperties,
    }
}

export default connect(mapStateToProps, {
    clickedNodeAction,
    showToastForBackend,
    showToastForFrontend
})(EditorialPanel);